import React, { useContext, useEffect, useState } from 'react';
import { Button, Col, ColumnProps, FormInput, FormNumber, FormSelect, Row, Table } from '@digital/ui';
import { Switch, Input } from 'antd';
import QuestionarioContextProvider from '../../../../../hooks/useQuestionario';
import ModalFinalizarEtapaRequisicao from '../ModalFinalizarEtapaRequisicao';
import ModalFinalizarEtapaFaturamentoDireto from '../ModalFinalizarEtapaFaturamentoDireto';
import {
  getTipoServicoAcordoFornecimentoOptions,
  getTipoServicoContratoAcordoFornecimento,
} from '@app/api/tipoServico';
import './custom.css';
import CurrencyInput from '@app/components/CurrencyInput';
import {
  deletarItemAcordoFinanceiro,
  getItenAcordoFinanceiroRequisicaoCompra,
  getItensRateaveisContratoIdOptions,
  incluirItemAcordoFinanceiroRequisicaoCompra,
  ItemAcordoFinanceiro,
  updateItemAcordoFinanceiroRequisicaoCompra,
} from '@app/api/itemAcordoFinanceiro';
import { Demanda, updateDemanda, updateTipoServicoDemanda } from '@app/api/demanda';
import { EStepQuestionarioDemanda } from '@app/enums/EStepQuestionarioDemanda';
import { isObjNotEmpty } from '@app/helpers/objHelper';
import { ETipoDemanda } from '@app/enums/ETipoDemanda';
const { TextArea } = Input;

const textValueNecessitaEspecificacao = `São necessidades que necessitam de documentação com o detalhamento do serviço, tais como: 

-Consultorias;   
-Serviço de engenharia;   
-Construção Civil e Terraplenagem;   
-Serviços de manutenção   
-Entre outros.`;

const textValueSemEspecificao = `São necessidades que não necessitam de detalhamento, tais como: 

-Treinamentos;   
-Cópia de Chaves;   
-Plastificação;   
-Reprografia;   
-Entre outros. `;

interface IDefinicaoProcessoFieldsProps {
  disabled?: boolean;
}

const DefinicaoProcessoFields = ({ disabled }: IDefinicaoProcessoFieldsProps) => {
  const { tipoDemanda, setTipoDemanda, setTipoContrato, statusCodigo, demandaData, setDemandaData } = useContext(
    QuestionarioContextProvider,
  );
  const [tipoServicoId, setTipoServicoId] = useState();
  const [contratoTipoServico, setContratoTipoServico] = useState<any>({});
  const [dadosItemAcordoFinanceiro, setDadosItemAcordoFinanceiro] = useState<ItemAcordoFinanceiro[]>([]);
  const [itensRateavelOptions, setItensRateavelOptions] = useState([]);
  const [updateTable, setUpdateTable] = useState(false);
  const [valorTotal, setValorTotal] = useState<number | undefined>();

  const [switchValorReferencia, setSwitchValorReferencia] = useState(
    demandaData ? demandaData.necessitaEspecificacao : true,
  );

  const onUpdateTable = () => {
    setUpdateTable(!updateTable);
  };

  useEffect(() => {
    if (demandaData) {
      if (switchValorReferencia != undefined) {
        demandaData.necessitaEspecificacao = switchValorReferencia;
      } else {
        demandaData.necessitaEspecificacao = true;
      }
      setDemandaData({ ...demandaData, necessitaEspecificacao: demandaData.necessitaEspecificacao, step: EStepQuestionarioDemanda.DefinicaodoProcesso });
    }
  }, [switchValorReferencia]);

  useEffect(() => {
    if (demandaData && demandaData.requisicaoCompraId) {
      getItenAcordoFinanceiroRequisicaoCompra(demandaData.requisicaoCompraId).then(data => {
        if (data) {
          if (data.length === 0) {
            setDadosItemAcordoFinanceiro([
              {
                id: '',
                indice: 1,
              },
            ]);
          } else if (data.length > 0) {
            setDadosItemAcordoFinanceiro(data);
          }
        }
      });
    }
  }, [demandaData, updateTable]);

  useEffect(() => {
    let valor = 0;
    dadosItemAcordoFinanceiro.forEach(e => {
      if (e.valor) {
        valor += e.valor;
      }
    });
    setValorTotal(valor);
  }, [dadosItemAcordoFinanceiro]);

  useEffect(() => {
    if (isObjNotEmpty(contratoTipoServico)) {
      getItensRateaveisContratoIdOptions(contratoTipoServico.id).then(data => {
        if (data) {
          setItensRateavelOptions(data);
          onUpdateTable();
        }
      });
    } else {
      setItensRateavelOptions([]);
      onUpdateTable();
    }
  }, [contratoTipoServico]);

  const handleIncluirLinha = () => {
    incluirItemAcordoFinanceiroRequisicaoCompra(demandaData.requisicaoCompraId).then(data => {
      onUpdateTable();
    });
  };

  const handleSelectTipoServico = (e: string) => {
    setTipoServicoId(e);
    updateTipoServicoDemanda({ tipoServicoId: e, demandaId: demandaData.id }).then(data => {
      if (data) {
        getTipoServicoContratoAcordoFornecimento(e).then(data => {
          setContratoTipoServico(data);
        });
        onUpdateTable();
      }
    });
  };

  useEffect(() => {
    if (tipoDemanda === 3) {
      if (demandaData!.tipoServicoId) {
        getTipoServicoContratoAcordoFornecimento(demandaData.tipoServicoId).then(data => {
          setContratoTipoServico(data);
        });
      }
    }
  }, [demandaData]);

  const handleDeleteLinha = (id: string) => {
    deletarItemAcordoFinanceiro(id).then(data => {
      if (data) onUpdateTable();
    });
  };

  const handleUpdateLinha = (record: any) => {
    let dados = { ...record, requisicaoCompraId: demandaData.requisicaoCompraId };
    updateItemAcordoFinanceiroRequisicaoCompra(dados).then(data => {
      if (data) {
        onUpdateTable();
      }
    });
  };

  const columns: ColumnProps<ItemAcordoFinanceiro>[] = [
    {
      title: '#',
      dataIndex: 'indice',
      width: '5%',
    },
    {
      title: 'Item do Contrato',
      width: '20%',
      render: (text, record) => {
        return (
          <>
            <FormSelect
              style={{ maxWidth: '300px' }}
              name="itemRateavelContratoId"
              options={itensRateavelOptions}
              value={record.itemRateavelContratoId}
              onSelect={e => handleUpdateLinha({ ...record, itemRateavelContratoId: e })}
              disabled={disabled || statusCodigo !== 1}
            />
          </>
        );
      },
    },
    {
      title: 'Tipo de Despesa',
      render: (text, record) => {
        return (
          <>
            <FormSelect
              name="tipoAlocacao"
              options={[
                { text: 'Centro de Custo', value: 'Centro de Custo' },
                { text: 'Ordem de Investimento', value: 'Ordem de Investimento' },
                { text: 'Ordem de Manutenção', value: 'Ordem de Manutenção' },
              ]}
              value={record.tipoAlocacao}
              onSelect={e => handleUpdateLinha({ ...record, tipoAlocacao: e })}
              disabled={disabled || statusCodigo !== 1}
            />
          </>
        );
      },
    },
    {
      title: 'Número',
      width: '8%',
      render: (text, record) => {
        return (
          <>
            <FormNumber
              value={record.alocacao}
              onChange={e => (record.alocacao = e)}
              name="alocacao"
              onKeyDown={e => {
                if (e.keyCode === 13) {
                  handleUpdateLinha({ ...record, alocacao: record.alocacao });
                }
              }}
              onBlur={e => handleUpdateLinha({ ...record, alocacao: record.alocacao })}
              disabled={disabled || statusCodigo !== 1}
            />
          </>
        );
      },
    },
    {
      title: 'QTD',
      width: '10%',
      render: (text, record) => {
        return (
          <>
            <CurrencyInput
              name="quantidade"
              value={record.quantidade}
              onChange={e => (record.quantidade = e)}
              onKeyDown={e => {
                if (e.keyCode === 13) {
                  handleUpdateLinha({ ...record, quantidade: record.quantidade });
                }
              }}
              onBlur={e => handleUpdateLinha({ ...record, quantidade: record.quantidade })}
              disabled={disabled || statusCodigo !== 1}
            />
          </>
        );
      },
    },
    {
      title: 'Preço Unit.',
      width: '10%',
      render: (text, record) => {
        return (
          <>
            <CurrencyInput name="precoUnitario" value={record.precoUnitario} disabled />
          </>
        );
      },
    },
    {
      title: 'Valor',
      width: '10%',
      render: (text, record) => {
        return (
          <>
            <CurrencyInput name="valor" value={record.valor} disabled />
          </>
        );
      },
    },
    {
      title: 'Ordem de Compra',
      width: '10%',
      render: (text, record) => {
        return (
          <>
            <FormInput name="ordemCompra" value={record.ordemCompra} disabled />
          </>
        );
      },
    },
    {
      title: 'Ações',
      render: (text, record) => {
        return <>{statusCodigo === 1 && <Button icon="ui-delete" onClick={() => handleDeleteLinha(record.id)} />}</>;
      },
    },
  ];

  return (
    <>
      <Row>
        <FormSelect
          id='mrn-select-tipo-servico'
          label="Tipo"
          name="tipo"
          span={4}
          onChange={value => {
            const tipoValor = Number(value);
            setTipoDemanda(tipoValor);
            let temp = {
              ...demandaData,
              necessitaEspecificacao: true,
              step: EStepQuestionarioDemanda.DefinicaodoProcesso,
              tipo: tipoValor
            } as Demanda;

            if (tipoValor == 1 && demandaData) {
              setSwitchValorReferencia(true);
            }

            setDemandaData(temp);

            if (demandaData && tipoValor === ETipoDemanda.AcordodeFornecimento) {
              updateDemanda(temp);
            }
          }}
          options={[
            { value: 1, text: 'Nova Contratação' },
            { value: 2, text: 'Aditivo' },
            { value: 3, text: 'Acordo de Fornecimento' },
            { value: 4, text: 'Faturamento Direto' },
          ]}
          placeholder="Selecione uma opção"
          required
          disabled={disabled || statusCodigo !== 1}
        />

        {tipoDemanda === ETipoDemanda.Aditivo && (
          <FormSelect
            label="Escolha o Tipo de Contrato"
            name="tipoContrato"
            id='mrn-select-tipoContrato'
            onChange={value => setTipoContrato(Number(value))}
            options={[
              { value: 'contrato', text: 'Contrato' },
              { value: 'pcs', text: 'PCS – Pedido de Compra de Serviço' },
            ]}
            span={4}
            required
            disabled={disabled || statusCodigo !== 1}
          />
        )}

        {tipoDemanda === ETipoDemanda.AcordodeFornecimento && (
          <>
            <ModalFinalizarEtapaRequisicao />
            <FormSelect
              id="mrn-select-tipoServico"
              getOptions={getTipoServicoAcordoFornecimentoOptions}
              label="Tipo de Serviço"
              name="tipoServicoId"
              span={4}
              required
              disabled={disabled || statusCodigo !== 1}
              onChange={e => handleSelectTipoServico(e)}
            // onSelect={e => handleSelectTipoServico(e)}
            />
            <FormInput label="Número RC Totvs" name="reqCompra" span={4} disabled />
          </>
        )}
      </Row>

      {tipoDemanda === ETipoDemanda.AcordodeFornecimento && (
        <>
          <Row>
            <CurrencyInput name="valorContrato" value={valorTotal} label="Valor Total" span={4} disabled />
            <FormInput
              name="numeroContrato"
              value={contratoTipoServico.numero}
              label="Número do Contrato"
              span={4}
              disabled
            />
          </Row>
          <Row style={{ paddingTop: '16px', paddingBottom: '16px', marginInline: '10px', paddingInline: '4px' }}>
            <Table columns={columns} dataSource={dadosItemAcordoFinanceiro || []} pagination={false} className="table-acordo" />
          </Row>
          {statusCodigo === 1 && (
            <Row style={{ marginBottom: '16px' }}>
              <Button
                style={{ float: 'right' }}
                title="INCLUIR LINHA"
                type="ghost"
                onClick={() => handleIncluirLinha()}
              />
            </Row>
          )}
        </>
      )}

    </>
  );
};

export default DefinicaoProcessoFields;
